"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dimmer = _interopRequireDefault(require("./Dimmer"));

var _Loader = _interopRequireDefault(require("./Loader"));

var _componentAnalytics = require("../Components/ComponentAnalytics/componentAnalytics");

var _utilities = require("../GlobalStyle/utilities/utilities.styled");

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ComponentLoader = function ComponentLoader(_ref) {
  var className = _ref.className,
      active = _ref.active,
      label = _ref.label,
      fullPage = _ref.fullPage;
  (0, _react.useEffect)(function () {
    (0, _componentAnalytics.trackMe)("ComponentLoader");
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Dimmer.default, {
    className: className,
    active: active,
    fullPage: fullPage
  }, /*#__PURE__*/_react.default.createElement(_utilities.SROnly, {
    role: "status"
  }, label), /*#__PURE__*/_react.default.createElement(_Loader.default, {
    content: label,
    fullPage: fullPage
  }));
};

ComponentLoader.propTypes = {
  className: _propTypes.default.string,
  active: _propTypes.default.bool,
  label: _propTypes.default.string,
  fullPage: _propTypes.default.bool
};
ComponentLoader.defaultProps = {
  active: !0,
  label: _Loader.default.defaultProps.content,
  fullPage: !1
};
var _default = ComponentLoader;
exports.default = _default;